

<div class="main-layout">
	 <app-header></app-header>
	<!-- <div class="content-layout"> -->
		<app-side-bar pageType="report"></app-side-bar>
		
	<!-- </div> -->
	<app-footer></app-footer>
</div>
